import ActionCable from "actioncable";

export const eventsEnum = {
  TICKET: "ticket",
  NOTIFICATION: "notifications",
  DEVICES: {
    playing: "playing",
    stopped: "stopped",
    download: "download",
    lastDownloaded: "lastDownloaded",
    received: "received",
    deviceStatus: "deviceStatus",
    blockPop: "blockPop",
    appVersionInfo: "appVersionInfo"
  },
  SCREENSHOTDATA: {
    deviceStatus: "deviceStatus",
    appVersionInfo: "appVersionInfo"
  },
  SEARCHEDDEVICE: {
    deviceStatus: "deviceStatus"
  }
};

const getDomain = window.localStorage.getItem("domain");

export const Socket = (function() {
  let _socket = null;
  return {
    socket() {
      if (_socket == null) {
        const url = process.env.REACT_APP_WS_URL;
        _socket = ActionCable.createConsumer(url);
      }
      return _socket;
    },
    connectWS(events, callback) {
      if (getDomain === "undefined" || !getDomain) {
        return;
      }
      const localSocket = Socket.socket();
      const domainID = JSON.parse(getDomain).id;
      try {
        if (!domainID) throw new Error("Domain ID is not defined");
        localSocket.subscriptions.create(
          { channel: `MessagesChannel`, domainID },
          {
            connected() {},
            disconnected() {},
            received(data) {
              const {
                message: { notification, status, ticket }
              } = data;
              if (ticket) callback(eventsEnum.TICKET, ticket);
              if (notification) callback(eventsEnum.NOTIFICATION, notification);

              if (status === events[status]) {
                callback(events, funcs[status](data.message));
              }
            }
          }
        );
      } catch (error) {
        return error.message;
      }
    }
  };
})();

const funcs = {
  notification: data => data.message.notification,

  ticket: data => data.message.ticket,

  playing: data => {
    const {
      currentPlayingType,
      currentPlayingName,
      lastDownloadedType,
      lastDownloadedName,
      mac
    } = data;
    const newData = {
      mac,
      currently_playing: data.currentPlayingName,
      campaign_name:
        currentPlayingType === "campaign" ? currentPlayingName : "",
      calendar_name:
        currentPlayingType === "calendar" ? currentPlayingName : "",
      last_downloaded_type: lastDownloadedType,
      last_downloaded_name: lastDownloadedName
    };
    return newData;
  },

  stopped: data => {
    const { mac } = data;
    const newData = {
      mac,
      currently_playing: undefined,
      campaign_name: undefined,
      calendar_name: undefined
    };
    return newData;
  },
  download: data => {
    const { totalContentToBeDownloaded, totalDownloaded, mac } = data;
    const newData = {
      total_downloaded: totalDownloaded,
      total_content_to_be_downloaded: totalContentToBeDownloaded,
      mac
    };
    return newData;
  },
  lastDownloaded: data => {
    const { lastDownloadedType, lastDownloadedName, mac } = data;
    const newData = {
      mac,
      last_downloaded_type: lastDownloadedType,
      last_downloaded_name: lastDownloadedName
    };
    return newData;
  },

  received: data => {
    const { receivedMediaType, receivedMediaName, mac } = data;
    const newData = {
      mac,
      received_media_type: receivedMediaType,
      received_media_name: receivedMediaName
    };
    return newData;
  },
  deviceStatus: data => {
    const { deviceStatus, mac } = data;
    const newData = { mac, status: deviceStatus };
    return newData;
  },
  blockPop: data => {
    const { block_pop, mac } = data;
    const newData = { mac, block_pop };
    return newData;
  },
  appVersionInfo: data => {
    const { version, mac } = data;
    const newData = { mac, electron_version: version };
    return newData;
  }
};
